import React, {useEffect,useRef,useState} from 'react';
import api from '@src/api/axiosInstance';
import './TemplateAssistant.css';

type Client={id:string;name:string;pets:{id:string;name:string}[]};
type Proposal={token:string;preview:string;label:string;category:string;payload:object};
type Props={waId:string;draft:string;currentDraft:string;onClose:()=>void;onSend:(payload:object)=>Promise<boolean>};
export default function TemplateAssistant({waId,draft,currentDraft,onClose,onSend}:Props){
 const [clients,setClients]=useState<Client[]>([]),[client,setClient]=useState(''),[pet,setPet]=useState('');
 const [loading,setLoading]=useState(true),[error,setError]=useState(''),[proposal,setProposal]=useState<Proposal|null>(null),[sending,setSending]=useState(false);
 const [requiresPet,setRequiresPet]=useState(false);
 const generation=useRef(0),sendingRef=useRef(false);
 const pets=clients.find(c=>String(c.id)===client)?.pets||[];
 const changed=draft!==currentDraft;
 const changedRef=useRef(changed);changedRef.current=changed;
 useEffect(()=>{if(changed){generation.current++;onClose();}},[changed,onClose]);
 async function prepare(clientId:string,petId:string){
  const version=++generation.current;setLoading(true);setError('');setProposal(null);
  try{
   const {data}=await api.post('/template-assistant/',{wa_id:waId,draft,client_id:clientId,pet_id:petId},{timeout:45000});
   if(version===generation.current&&!changedRef.current){
    if(data.workflow==='form'){
     window.dispatchEvent(new CustomEvent('cvparc-starter-template',{detail:{...data,wa_id:waId}}));onClose();return;
    }
    setRequiresPet(data.requires_pet===true);if(!data.requires_pet)setProposal(data);
   }
  }catch(e:any){if(version===generation.current)setError(e.response?.data?.detail||'No se ha podido preparar la propuesta. Tu borrador sigue intacto.');}
  finally{if(version===generation.current)setLoading(false);}
 }
 useEffect(()=>{
  let alive=true;
  api.get('/template-context/',{params:{wa_id:waId}}).then(({data})=>{
   if(!alive||changedRef.current)return;
   if(!data.identity_fresh)throw Error('Actualiza los datos de Wakyma antes de preparar el mensaje.');
   const rows:Client[]=data.clients||[];setClients(rows);setLoading(false);
   if(!rows.length){setError('No hay un cliente activo de Wakyma asociado a este número.');return;}
   if(rows.length===1){const id=String(rows[0].id);setClient(id);void prepare(id,'');}
  }).catch((e:any)=>{if(alive){setLoading(false);setError(e.response?.data?.detail||e.message||'No se han podido cargar los datos de Wakyma.');}});
  return()=>{alive=false;generation.current++;};
 },[waId,draft]);
 async function send(){
  if(!proposal||changed||sendingRef.current)return;
  sendingRef.current=true;setSending(true);
  try{if(await onSend({...proposal.payload,template_proposal:proposal.token}))onClose();}
  finally{sendingRef.current=false;setSending(false);}
 }
 if(changed)return null;
 return <section className="cv-template-assistant" aria-label="Revisar mensaje" aria-live="polite">
  <header><strong>Revisar mensaje</strong><button type="button" onClick={onClose} disabled={sending} aria-label="Cerrar propuesta">×</button></header>
  {!proposal&&!loading&&clients.length>0&&<div className="cv-template-identity">
   {clients.length>1&&<label>Cliente<select value={client} onChange={e=>{setClient(e.target.value);setPet('');setRequiresPet(false);setError('');}}><option value="">Selecciona cliente</option>{clients.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}</select></label>}
   {requiresPet&&<label>¿A qué mascota te refieres?<select aria-label="Mascota" value={pet} onChange={e=>{setPet(e.target.value);setError('');}}><option value="">Selecciona mascota</option>{pets.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}</select>{!pets.length&&<span>No hay mascotas activas para este cliente.</span>}</label>}
  </div>}
  {loading&&<p className="cv-template-loading">Analizando conversación…</p>}
  {error&&<p role="alert">{error}</p>}
  {proposal&&<><small>{proposal.label} · {proposal.preview.length}/1024</small><div className="cv-template-preview">{proposal.preview}</div>
  </>}
  <footer><button type="button" disabled={sending} onClick={onClose}>Volver al borrador</button>
   {!proposal&&!loading&&<button type="button" className="primary" disabled={!client||(requiresPet&&!pet)||changed} onClick={()=>prepare(client,pet)}>Preparar mensaje</button>}
   {proposal&&<button type="button" className="primary" disabled={changed||sending} onClick={send}>Enviar mensaje</button>}
  </footer>
 </section>;
}
